import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  day: {
    width: theme.px(32),
    height: theme.px(32),
    fontSize: theme.tokens.typography.variant.body3.fontSize,
    color: theme.tokens.colors.text.light.primary,
    padding: 0,
    margin: 0,
    borderRadius: theme.tokens.radius.s,
    '&:hover': {
      backgroundColor: 'none',
      border: `${theme.tokens.border.s}px solid ${theme.tokens.colors.original.brand.primary}`,
    },
  },
  hidden: {
    opacity: 0,
    pointerEvents: 'none',
  },
  holiday: {
    color: theme.tokens.colors.accent.text.error,
  },
  current: {
    color: theme.tokens.colors.original.brand.primary,
    fontWeight: theme.tokens.typography.variant.subtitle1.fontWeight,

    '&:not(.Mui-selected)': {
      border: 'none',

      '&:hover': {
        border: `${theme.tokens.border.s}px solid ${theme.tokens.colors.original.brand.primary}`,
      },
    },
  },
  dayDisabled: {
    pointerEvents: 'none',
    color: theme.tokens.colors.text.light.tertirary,
    cursor: 'default',

    '&:hover': {
      border: 'none',
      background: 'none',
    },
  },
  dayWrapper: {
    padding: `0 ${theme.tokens.spacing['2']}px`,
  },
  dayWrapperInRange: {
    backgroundColor: theme.tokens.colors.original.brand.secondary,
    borderRadius: 0,
  },
  dayWrapperStart: {
    borderTopLeftRadius: theme.tokens.radius.s,
    borderBottomLeftRadius: theme.tokens.radius.s,
    paddingLeft: 0,
    marginLeft: theme.tokens.spacing['2'],
  },
  dayWrapperEnd: {
    borderTopRightRadius: theme.tokens.radius.s,
    borderBottomRightRadius: theme.tokens.radius.s,
    paddingRight: 0,
    marginRight: theme.tokens.spacing['2'],
  },
  daySelected: {
    color: theme.tokens.colors.text.dark.primary,
    backgroundColor: theme.tokens.colors.original.brand.primary,
    fontWeight: theme.typography.fontWeightMedium,
    '&:hover': {
      backgroundColor: theme.tokens.colors.original.brand.primary,
    },
  },
}));

export default useStyles;
